// extracted by mini-css-extract-plugin
export var header = "Header-module--header--1Qt4T";
export var fullContainer = "Header-module--fullContainer--2IRxr";
export var inner = "Header-module--inner--2Z3CC";
export var logoHeader = "Header-module--logoHeader--1mLvY";